/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useContext } from 'react';
import { SaveButton, useNotify, useRecordContext, useRedirect, useRefresh, useSaveContext } from 'react-admin';
import { getToken, getRefreshToken } from '../authentication/authProvider';
import { useFormContext, useFormState } from 'react-hook-form';

const isProdMod = process.env.NODE_ENV === 'production';

export const ContractSaveButton = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();
  const { getValues } = useFormContext();
  const { isSubmitting } = useFormState();
  const saveContext = useSaveContext();
  const saving = isSubmitting || Boolean(saveContext?.saving);

  let preneedId = '';

  if (isProdMod) {
    preneedId = '14';
  } else {
    preneedId = '55';
  }

  const transformNegativeValues = (data: any) => {
    const linesTotal = data.lines.reduce((accumulator: any, contract: any) => {
      return accumulator + contract.price;
    }, 0);

    const newLines = data.lines.map((a: any) => Object.assign({}, a));

    newLines.forEach(function (line: any) {
      line.price *= -1;
    });

    if (linesTotal < 0) {
      return {
        ...data,
        lines: newLines,
      };
    } else {
      return {
        ...data,
      };
    }
  };

  return (
    <SaveButton
      type="button"
      // alwaysEnable bypasses SaveButton's built-in isSubmitting/saving disable,
      // which allowed double clicks to create duplicate contracts
      alwaysEnable={!saving}
      disabled={saving}
      // transform={transformNegativeValues}
      mutationOptions={{
        onSuccess: async (response) => {
          try {
            if (response['lines'].length === 0) {
              notify(
                `Error creating or updating estimate in QuickBooks. \n You need to add one product at least.`,
                {
                  type: 'error',
                  autoHideDuration: 5000,
                  multiLine: true,
                }
              );
              return;
            } 
            
            if (response['lines'].some((e: any) => e.tax == null)) {
              notify(
                `Error creating or updating estimate in QuickBooks. \n One or more Contract lines missing tax.`,
                {
                  type: 'error',
                  autoHideDuration: 5000,
                  multiLine: true,
                }
              );
              return;
            }

            // if (response.is_preneed && !response['lines'].some((e: any) => e.item == preneedId)) {
            //   notify(
            //     `Contract is missing Pre-Need Fee.`,
            //     {
            //       type: 'info',
            //       autoHideDuration: 5000,
            //       multiLine: true,
            //     }
            //   );
            // }

            // Only proceed with QuickBooks if we have a valid response ID
            if (!response.id) {
              notify(
                'Error: Contract ID not available',
                {
                  type: 'error',
                  autoHideDuration: 5000,
                }
              );
              return;
            }

            const result = await fetch(
              `${process.env.REACT_APP_PAPERMAN_API_URL}quickbooks/estimates/${response.id}`,
              {
                method: 'POST',
                headers: { 
                  Authorization: `Bearer ${await getToken()}`,
                  'Refresh-Token': await getRefreshToken(),
                },
              }
            );

            if (result.status >= 200 && result.status < 300) {
              notify(
                'Estimate in QuickBooks created or updated successfully',
                {
                  type: 'success',
                }
              );
              redirect(`/contracts/${response.id}/show`);
              refresh();
            } else {
              const body = await result.json();
              const message = body.error?.Error?.[0]?.Detail ?? body.error;
              notify(
                `Error creating or updating estimate in QuickBooks. \n ${
                  message != null && message !== '' ? message : ''
                }`,
                {
                  type: 'error',
                  autoHideDuration: 5000,
                  multiLine: true,
                }
              );
            }
          } catch (e) {
            console.warn(e);
            notify(JSON.stringify(e));
          }
        },
      }}
    />
  );
};
